import SelectExportType from '../LTLandVolumeTLPages/SelectExportType/SelectExportType'
import ShowHideColumns from '../QuotesGridPage/Table/ShowHideColumns'
import SelectStatus from './SelectStatus'
import { ToolbarProps } from '../../pages/invoices/models';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { ToolbarStyled } from '../Toolbar.styled';
import { checkErrorAPICall } from '../../helpers/checkErrorAPICall';
import { InputStyled } from '../Inputs.styled';
import { RootState } from '../../../setup';
import AgingCards from './AgingCards';

let cancelToken
const GET_INVOICES = '/applet/v1/invoice'
const OPEN_INVOICES = '/applet/v1/invoice/open'

const Toolbar = ({filters, setFilters, columns, setColumns, invoices, setInvoices, setLoading, rowsPerPage, pageNumber, setPageNumber, setTotalResults, ascOrDesc, setAscOrDesc, field, setField}: ToolbarProps) => {
    const dispatch = useDispatch()
    const [clicked, setClicked] = useState(false)
    const [filtering, setFiltering] = useState(false)
    const [openInvoices, setOpenInvoices] = useState([])
    const [agingFilters, setAgingFilters] = useState({dueDaysFrom: undefined, dueDaysTo: undefined})
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number

    const handleSearch = (e) => {
        setFilters({...filters, [e.target.name]: e.target.value})
    }

    const defaultCall = () => {
        setLoading(true)
    
        if (typeof cancelToken != typeof undefined) {
          cancelToken.cancel('Operation canceled due to new request.')
        }
    
        cancelToken = axios.CancelToken.source()

        axios.get(GET_INVOICES, {
            cancelToken: cancelToken.token,
            params: {
                page: pageNumber + 1,
                limit: rowsPerPage,
                'sort[]': `${field}:${ascOrDesc}`,
                paid: filters.status === 'Paid' ? true : filters.status === 'All' ? null : filters.status === 'Unpaid' ? false : null,
            }
        }).then((results) => {
            setTotalResults(results.data.data.pagingDetails.totalResults)
            setInvoices(results.data.data.results)
            setLoading(false)
        }).catch(error => {
          setLoading(false)
          checkErrorAPICall(error, dispatch, 'Invoices')
        })
    }

    useEffect(() => {
        if(((filters.invoiceNumber || filters.BOLNumber || filters.type !== 'All') && filtering) || agingFilters?.dueDaysFrom || agingFilters?.dueDaysTo){
            updateFilters()
        }else{
            defaultCall()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNumber, rowsPerPage])

    const updateFilters = () => {
        if(clicked){

        }else {
            setLoading(true)

            if (typeof cancelToken != typeof undefined) {
                cancelToken.cancel('Operation canceled due to new request.')
            }
        
            //Save the cancel token for the current request
            cancelToken = axios.CancelToken.source()
        
            axios.get(GET_INVOICES, {
                cancelToken: cancelToken.token,
                params: {
                    page: pageNumber + 1,
                    limit: rowsPerPage,
                    invoiceNumber: filters.invoiceNumber.trim(),
                    BOLNumber: filters.BOLNumber.trim(),
                    paid: filters.status === 'Paid' ? true : filters.status === 'All' ? null : filters.status === 'Unpaid' ? false : null,
                    dueDaysFrom: agingFilters?.dueDaysFrom,
                    dueDaysTo: agingFilters?.dueDaysTo,
                    'sort[]': `${field}:${ascOrDesc}`
                }
            }).then((results) => {
                setTotalResults(results.data.data.pagingDetails.totalResults)
                setInvoices(results.data.data.results)
                setLoading(false)

                if(results.data.data.results.length){
                    let newSearch = {id: uuidv4(), ...filters, hashId: `${JSON.stringify(filters.invoiceNumber)}${JSON.stringify(filters.BOLNumber)}${JSON.stringify(filters.status)}`}
                    let existingSearches = JSON.parse(localStorage.getItem("historyInvoicesGrid")) || []
                    let isDuplicated = existingSearches.find(search => search.hashId === newSearch.hashId)
                
                    if(isDuplicated){
                
                    }else{
                        existingSearches.unshift(newSearch);
                        localStorage.setItem("historyInvoicesGrid", JSON.stringify(existingSearches));
                    }
                }
            }).catch(error => {
                setLoading(false)
                checkErrorAPICall(error, dispatch, 'Invoices')
            })
        }
    }

    const updateFiltersFirstCall = (params) => {
        setPageNumber(0)
        setLoading(true)

        if (typeof cancelToken != typeof undefined) {
            cancelToken.cancel('Operation canceled due to new request.')
        }
    
        //Save the cancel token for the current request
        cancelToken = axios.CancelToken.source()
    
        axios.get(GET_INVOICES, {
            cancelToken: cancelToken.token,
            params: {
                page: (params?.pageNumber || params?.pageNumber === 0) ? params?.pageNumber + 1 : pageNumber + 1,
                limit: rowsPerPage,
                invoiceNumber: params?.invoiceNumber === '' ? params?.invoiceNumber : filters.invoiceNumber.trim(),
                BOLNumber: params?.BOLNumber === '' ? params?.BOLNumber : filters.BOLNumber.trim(),
                paid: (params?.status === 'Unpaid') ? false : filters.status === 'Paid' ? true : filters.status === 'All' ? null : filters.status === 'Unpaid' ? false : null,
                dueDaysFrom: params.dueDaysFrom === 'no' ? undefined : agingFilters?.dueDaysFrom,
                dueDaysTo: params.dueDaysTo === 'no' ? undefined : agingFilters?.dueDaysTo,
                'sort[]': `${field}:${ascOrDesc}`
            }
        }).then((results) => {
            setInvoices(results.data.data.results)
            setTotalResults(results.data.data.pagingDetails.totalResults)
            setClicked(false)
            setLoading(false)

            if(results.data.data.results.length){
                let newSearch = {id: uuidv4(), ...filters, hashId: `${JSON.stringify(filters.invoiceNumber)}${JSON.stringify(filters.BOLNumber)}${JSON.stringify(filters.status)}`}
                let existingSearches = JSON.parse(localStorage.getItem("historyInvoicesGrid")) || []
                let isDuplicated = existingSearches.find(search => search.hashId === newSearch.hashId)
            
                if(isDuplicated){
            
                }else{
                    existingSearches.unshift(newSearch);
                    localStorage.setItem("historyInvoicesGrid", JSON.stringify(existingSearches));
                }
            }
        }).catch(error => {
            setLoading(false)
            checkErrorAPICall(error, dispatch, 'Invoices')
        })
    }

    const getOpenInvoices = () => {
        axios.get(OPEN_INVOICES, {
            params: {
                'dateRange[]': '0|30|60|90'
            }
        }).then((results) => {
            setOpenInvoices(results.data.data.results.openInvoices)
        })
    }

    const filter = () => {
        setAgingFilters({dueDaysFrom: undefined, dueDaysTo: undefined})
        setClicked(true)
        setFiltering(true)
        setPageNumber(0)
        updateFiltersFirstCall({pageNumber: 0, dueDaysFrom: 'no', dueDaysTo: 'no'})
    }

    useEffect(() => {
        getOpenInvoices()
    }, [])

    useEffect(() => {
        if(ascOrDesc){
          updateFiltersFirstCall({})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ascOrDesc, field])

    useEffect(() => {
        if(agingFilters.dueDaysFrom || agingFilters.dueDaysFrom === 0){
            setFilters({invoiceNumber: '', BOLNumber: '', status: 'Unpaid'})
            updateFiltersFirstCall({invoiceNumber: '', BOLNumber: '', status: 'Unpaid'})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [agingFilters])

    return (
        <ToolbarStyled className="row mb-8">
            <div className="col-12 mb-7">
                <div className="row">
                    <div className="col-12 d-none d-xl-flex">
                        <AgingCards
                            color={'#51CD89'}
                            borderColor={'#4eb765'}
                            title={openInvoices[0]?.aging}
                            amount={openInvoices[0]?.amount}
                            className='w-100 me-5'
                            onClick={() => setAgingFilters({dueDaysFrom: 0, dueDaysTo: 0})}
                        />
                        <AgingCards
                            color={'#009EF7'}
                            borderColor={'#0287f4'}
                            title={`${openInvoices[1]?.aging} Past Due`}
                            amount={openInvoices[1]?.amount}
                            className='w-100 me-5'
                            onClick={() => setAgingFilters({dueDaysFrom: 0, dueDaysTo: 30})}
                        />
                        <AgingCards
                            color={'#6F42C1'}
                            borderColor={'#573499'}
                            title={`${openInvoices[2]?.aging} Past Due`}
                            amount={openInvoices[2]?.amount}
                            className='w-100 me-5'
                            onClick={() => setAgingFilters({dueDaysFrom: 31, dueDaysTo: 60})}
                        />
                        <AgingCards
                            color={'#F1416C'}
                            borderColor={'#ce375a'}
                            title={`${openInvoices[3]?.aging} Past Due`}
                            amount={openInvoices[3]?.amount}
                            className='w-100 me-5'
                            onClick={() => setAgingFilters({dueDaysFrom: 61, dueDaysTo: 90})}
                        />
                        <AgingCards
                            color={'#fd7e14'}
                            borderColor={'#e06d0f'}
                            title={`${openInvoices[4]?.aging} Past Due`}
                            amount={openInvoices[4]?.amount}
                            className='w-100'
                            onClick={() => {
                                setAgingFilters({dueDaysFrom: 91, dueDaysTo: undefined})
                                setAscOrDesc('desc')
                                setField('invoiceNumber')
                            }}
                        />
                    </div>
                    <div className="col-6 col-sm-4 d-flex d-xl-none">
                        <AgingCards
                            color={'#51CD89'}
                            borderColor={'#4eb765'}
                            title={openInvoices[0]?.aging}
                            amount={openInvoices[0]?.amount}
                            className='w-100'
                        />
                    </div>
                    <div className="col-6 col-sm-4 d-flex d-xl-none">
                        <AgingCards
                            color={'#009EF7'}
                            borderColor={'#0287f4'}
                            title={`${openInvoices[1]?.aging} Days`}
                            amount={openInvoices[1]?.amount}
                            className='w-100'
                        />
                    </div>
                    <div className="col-6 col-sm-4 d-flex d-xl-none mt-2 mt-sm-0">
                        <AgingCards
                            color={'#6F42C1'}
                            borderColor={'#573499'}
                            title={`${openInvoices[2]?.aging} Days`}
                            amount={openInvoices[2]?.amount}
                            className='w-100'
                        />
                    </div>
                    <div className="col-6 col-sm-4 d-flex d-xl-none mt-2">
                        <AgingCards
                            color={'#F1416C'}
                            borderColor={'#ce375a'}
                            title={`${openInvoices[3]?.aging} Days`}
                            amount={openInvoices[3]?.amount}
                            className='w-100'
                        />
                    </div>
                    <div className="col-6 col-sm-4 d-flex d-xl-none mt-2">
                        <AgingCards
                            color={'#fd7e14'}
                            borderColor={'#e06d0f'}
                            title={`${openInvoices[4]?.aging} Days`}
                            amount={openInvoices[4]?.amount}
                            className='w-100'
                        />
                    </div>
                </div>
            </div>
            <div className="col-12 col-sm-6 mb-5 mb-sm-0">
                <div className="row">
                    <div className="col-8 d-flex align-items-center pe-0">
                        <InputStyled
                            name='invoiceNumber'
                            value={filters.invoiceNumber}
                            onChange={handleSearch}
                            placeholder='Invoice#'
                            className='form-control me-3'
                            autoComplete='off'
                            fontSize={fontSize}
                            onKeyPress={(e) => {
                                if(e.code === "Enter"){
                                  handleSearch(e)
                                  filter()
                                }
                            }}
                        />
                        <InputStyled
                            name='BOLNumber'
                            value={filters.BOLNumber}
                            onChange={handleSearch}
                            placeholder='BOL#'
                            className='form-control'
                            autoComplete='off'
                            fontSize={fontSize}
                            onKeyPress={(e) => {
                                if(e.code === "Enter"){
                                  handleSearch(e)
                                  filter()
                                }
                            }}
                        />
                    </div>
                    <div className="col-4">
                        <SelectStatus
                            filters={filters}
                            setFilters={setFilters}
                        />
                    </div>
                </div>
            </div>
            <div className="col-11 col-sm-5 d-flex align-items-center pe-0">
                <div
                    className='btn btn-secondary me-3'
                    onClick={() => {
                        setFilters({
                            invoiceNumber: '',
                            BOLNumber: '',
                            status: 'Unpaid',
                        })
                        setClicked(true)
                        setFiltering(false)
                        setPageNumber(0)
                        defaultCall()
                        setAgingFilters({dueDaysFrom: undefined, dueDaysTo: undefined})
                    }}
                >
                    Clear
                </div>
                <div
                    className='btn btn-primary'
                    onClick={() => {
                        filter()
                    }}
                >
                    Search
                </div>
            </div>
            <div className="col-1 d-flex align-items-center justify-content-end pt-5 pt-xl-0">
                <div className="me-3">
                    <ShowHideColumns
                        columns={columns.filter(c => c.title !== '')}
                        setColumns={setColumns}
                        disabled={invoices?.length ? false : true}
                        columnsFor='Invoices Grid'
                    />
                </div>
                <SelectExportType
                    fileName="Invoices"
                    columns={columns?.filter(column => column.hidden === false)}
                    dataColumns={invoices}
                    disabled={invoices?.length ? false : true}
                    setLoading={setLoading}
                    filtersForData={{
                        invoiceNumber: filters.invoiceNumber.trim(),
                        BOLNumber: filters.BOLNumber.trim(),
                        paid: filters.status === 'Paid' ? true : filters.status === 'All' ? null : filters.status === 'Unpaid' ? false : null,
                        dueDaysFrom: agingFilters?.dueDaysFrom,
                        dueDaysTo: agingFilters?.dueDaysTo,
                        'sort[]': `${field}:${ascOrDesc}`
                    }}
                />
            </div>
        </ToolbarStyled>
    )
}

export default Toolbar